export enum ResourceType{
    UserAccount,
    UserBilling,
    UserJob,
    TenantAccount,
    TenantMember
}